import { render, staticRenderFns } from "./orderVerify.vue?vue&type=template&id=15bbd5e6&scoped=true&"
import script from "./orderVerify.vue?vue&type=script&lang=js&"
export * from "./orderVerify.vue?vue&type=script&lang=js&"
import style0 from "./orderVerify.vue?vue&type=style&index=0&id=15bbd5e6&lang=less&scoped=true&"
import style1 from "./orderVerify.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bbd5e6",
  null
  
)

export default component.exports